module.exports = __webpack_public_path__ + "hat-twilight-red.a7dcd8ccee07296bb781.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/hat-twilight-red.svg
// module id = ../../../../../src/assets/img/hat-twilight-red.svg
// module chunks = main